import React from "react";
import ChartArea from "../../components/ChartArea";
import NrHauls from "../../components/NrHauls";
import TowSoakTime from "../../components/TowSoakTime";
import FishingDepth from "../../components/FishingDepth";
import { getGearCodeValidation } from "../../constants/effortValidations";

export default function EffortForm2(props) {
  if (props.currentStep !== 2) {
    return null;
  }

  let gearValidation = getGearCodeValidation(
    props.gearcode,
    props.gearCodeOptions
  );
  const handleChartAreaChange = (event, reason) => {
    let newState = { ...props.currentState };
    if (reason && reason.hasOwnProperty("AREA_CODE")) {
      newState.chart_area = reason.AREA_CODE;
    } else {
      newState.chart_area = "";
    }
    props.updateState({ ...newState });
  };

  const handleTowSoakTimeChange = (event) => {
    const { name, value } = event.target;
    let state = { ...props.currentState };
    const towSoakTime = {};
    if (name === "tow_soak_time_hours") {
      towSoakTime.hours = value;
      towSoakTime.minutes = state.tow_soak_time.minutes;
    } else if (name === "tow_soak_time_minutes") {
      towSoakTime.hours = state.tow_soak_time.hours;
      towSoakTime.minutes = value;
    }
    props.updateState({
      ...state,
      tow_soak_time: { hours: towSoakTime.hours, minutes: towSoakTime.minutes },
    });
  };

  const handlePreferenceChange = (event) => {
    event.preventDefault();
    const { newValue, field } = event.currentTarget.dataset;
    if (!newValue) {
      console.log("No new value provided");
      return;
    }
    if (!field) {
      console.error("No field provided");
      return;
    }
    let newState = { ...props.currentState };
    newState[field] = newValue;
    props.updateState({ ...newState });
  };

  return (
    <div className="margAll10">
      <ChartArea
        changeHandler={handleChartAreaChange}
        chartAreaOptions={props.chart_area_options}
        chart_area={props.chart_area}
        handleGearPreferenceChange={handlePreferenceChange}
        chart_preference={props.preferences.area ? props.preferences.area : []}
        helpText={props.helpText}
      />
      {props.showNumberOfHauls && (
        <NrHauls
          handleInputChange={props.handleChange}
          number_of_hauls={props.number_of_hauls}
          helpText={props.helpText}
          validation={gearValidation}
        />
      )}
      {props.showTowSoakTime && (
        <TowSoakTime
          handleInputChange={handleTowSoakTimeChange}
          tow_soak_time={props.tow_soak_time}
          helpText={props.helpText}
          validation={gearValidation}
        />
      )}

      <FishingDepth
        handleInputChange={props.handleChange}
        fishing_depth={props.fishing_depth}
        fishing_depth_uom={props.fishing_depth_uom}
        helpText={props.helpText}
      />
    </div>
  );
}
